import React from 'react'
import ReactDOM from 'react-dom'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import './index.scss'

import injectTapEventPlugin from 'react-tap-event-plugin'
injectTapEventPlugin()

import MainContainer from './container/Main'
import { Provider } from 'react-redux'
import store from './store'

const ThemedApp = () => (
  <Provider store={store}>
    <MuiThemeProvider>
        <MainContainer />
    </MuiThemeProvider>
  </Provider>
)

ReactDOM.render(
  <ThemedApp />,
  document.getElementById('root')
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/